export const MILEAGE_RANGE = 10_000; // 10,000 km
